<template>
  <div>
    <add-user :is-active.sync="isAdding" @added="userAdded" />
    <add-referral :is-active.sync="isAddingReferral" @added="paymentTypeAdded" />
    <data-table
      title="Users"
      ref="table"
      :url="url"
      :headers="headers"
      searchable
      :csv="true"
      :archive="true"
      userFilter="true"
      @update-archived="(status) => (this.showArchived = status)"
      csvFileName="users.csv"
      :csvFields="csvFields"
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <!-- new date formatter -->
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | moment }}
      </template>

      <template slot="action.icons">
        <v-row>
          <v-btn
            color="primary"
            class="mr-2"
            :loading="loadingCsv"
            :disabled="loadingCsv"
            @click="downloadCsv"
            title="Download CSV of Data"
          >
            <v-icon>mdi-download</v-icon>Download User Balances</v-btn
          >
          <v-btn color="primary" class="mr-2" @click="syncUserBalance">
            <v-icon class="ml-2" color="light-blue lighten-4">
              mdi-sync
            </v-icon>
            Sync user balances
          </v-btn>
          <v-btn color="primary" class="mr-2" @click="isAdding = true">
            Add User
            <v-icon class="ml-2" color="light-blue lighten-4">
              mdi-account-plus
            </v-icon>
          </v-btn>
          <v-btn color="primary" @click="isAddingReferral = true">
            Add new referral
            <v-icon class="ml-2" color="light-blue lighten-4">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-row>
      </template>
      <span slot="item.type" slot-scope="{ item }" v-text="getUserType(item)" />

      <template slot="item.status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_active">mdi-progress-check</v-icon>
        <v-icon color="warning" v-else>mdi-information-outline</v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import get from "lodash/get";
import moment from "moment";
import { getUserType } from "./utils";
import { AsyncParser } from "json2csv";
import { downloadFile } from "../../components/tables/utils";

export default {
  components: { AddUser: require("./userForm").default, AddReferral: require("./addReferral").default },
  data() {
    return {
      currentFilter: "all",
      isAdding: false,
      isAddingReferral: false,
      showArchived: false,
      url: "api/v1/users",
      loadingCsv: false,
      headers: this.pairTableLabelWithValue({
        // ID: "id",
        "Created at": "created_at",
        "First Name": "first_name",
        "Last Name": "last_name",
        Email: "email",
        Country: "country",
        "Phone Number": "full_phone_number",
        Type: "type",
        "Compliance Scoring": "compliance_score",
        "Activation Scoring": "activation_scoring",
        Status: "status",
      }),

      csvFields: [
        {
          label: "Full names",
          value: "full_name",
          default: "",
        },
        {
          label: "Phone number",
          value: "full_phone_number",
          default: "",
        },
        {
          label: "User email",
          value: "email",
          default: "",
        },
        {
          label: "Birth Date",
          value: "birth_date",
          default: "",
        },
        {
          label: "Birth Location",
          value: "birth_location",
          default: "",
        },
        {
          label: "Country",
          value: "country",
          default: "",
        },
        {
          label: "User Type",
          value: "client.type",
          default: "",
        },
        {
          label: "User Status",
          // eslint-disable-next-line no-unused-vars
          value: function (row, field, data) {
            // field = { label, default }
            // data = full data object
            return row.is_active ? "active" : "not active";
          },
          default: "",
        },
        {
          label: "Create Date",
          value: "created_at",
          default: "",
        },
      ],
      userBalanceFields: [
        {
          label: "Id",
          value: "id",
          default: "",
        },
        {
          label: "Full names",
          value: "full_name",
          default: "",
        },
        {
          label: "Email",
          value: "email",
          default: "",
        },
        {
          label: "Country Code",
          value: "country_code",
          default: "",
        },
        {
          label: "Phone number",
          value: "full_phone_number",
          default: "",
        },
        {
          label: "Wallet Address",
          value: "client.wallet_address",
          default: "",
        },
        {
          label: "Token Balance",
          value: "client.token_balance",
          default: "",
        },
        {
          label: "total Withdraws",
          value: "total_withdraws",
          default: "",
        },
        {
          label: "total Withdraws Fees",
          value: "total_withdraws_fees",
          default: "",
        },
        {
          label: "Total Transfers From balance",
          value: "total_transfers_from_balance",
          default: "",
        },
        {
          label: "Total Transfers From balance Fees",
          value: "total_transfers_from_balance_fees",
          default: "",
        },
        {
          label: "Total Deposits",
          value: "total_deposits",
          default: "",
        },
        {
          label: "Total Deposits Fees",
          value: "total_deposits_fees",
          default: "",
        },
        {
          label: "Total Received Transfers",
          value: "total_received_transfers",
          default: "",
        },
        {
          label: "Total Received Transfers Fees",
          value: "total_received_transfers_fees",
          default: "",
        },
        {
          label: "Received Amount",
          value: "received_amount",
          default: "",
        },
        {
          label: "Transferred Amount",
          value: "transferred_amount",
          default: "",
        },
        {
          label: "Current Balance",
          value: "balance_in_euro",
          default: "",
        },
        {
          label: "Calculated Balance",
          value: "calculated_balance",
          default: "",
        },
        {
          label: "Diff in Balance",
          value: "diff_in_balance",
          default: "",
        },
        {
          label: "Token Synced At",
          value: "client.token_synced_at",
          default: "",
        },

        {
          label: "User Type",
          value: "client.type",
          default: "",
        },
        {
          label: "User Status",
          // eslint-disable-next-line no-unused-vars
          value: function (row, field, data) {
            // field = { label, default }
            // data = full data object
            return row.is_active ? "active" : "not active";
          },
          default: "",
        },
        {
          label: "Create Date",
          value: "created_at",
          default: "",
        },
      ],
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    showArchived: function (val) {
      console.log("user ======>", val);
      if (val) {
        this.url = `/api/v1/users?with_trashed=true`;
      } else {
        this.url = `/api/v1/users`;
      }
    },
  },

  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY hh:mm:ss");
    },
  },

  methods: {
    async syncUserBalance() {
      let lastSyncDate = localStorage.getItem("last_date_of_user_sync");
      if (lastSyncDate != null && moment(lastSyncDate).isAfter(moment().subtract(1, "hours"))) {
        Notify.error("Too Many Sync Requests.Try again in an hour");
      } else {
        await Notify.confirm(`Please note that this action takes about an hour to complete`).then(
          () => {
            this.$http
              .get(`/api/v1/users/sync-balances`)
              .then(async () => {
                localStorage.setItem("last_date_of_user_sync", await moment(new Date()).format());
                Notify.success("User balance synchronisation has been started");
                window.location.reload();
              })
              // eslint-disable-next-line no-unused-vars
              .catch((error) => {
                Notify.error(error.message);
              });
          },
        );
      }
    },
    showDetails({ id }) {
      this.$router.push({ name: "users.show", params: { id } });
    },
    getUserType,
    userAdded({ message }) {
      this.isAdding = false;
      this.$refs.table.fetchData();
      Notify.success(message);
    },
    paymentTypeAdded ({message}) {
      this.isAddingReferral = false;
      Notify.success(message);
    },
    async downloadCsv() {
      await Notify.confirm(`Proceed`).then(() => {
        this.loadingCsv = true;
        let csv = "";
        const fields = this.userBalanceFields;

        const asyncParser = new AsyncParser({ fields }, { objectMode: true });
        asyncParser.processor
          .on("data", (chunk) => (csv += chunk.toString()))
          .on("end", () => downloadFile(csv, "userbalances.csv"))
          // eslint-disable-next-line no-unused-vars
          .on("error", (err) => {
            // console.error(err)
            csv = "";
          });

        this.fetchCsvData(this.url, asyncParser)
          .then(() => {
            Notify.success("Data has been successfully downloaded");
          })
          .catch(() => {
            // if there is an error, we clear the csv data
            csv = "";
          })
          .finally(() => (this.loadingCsv = false));
      });
    },
    fetchCsvData(url, asyncParser) {
      // all the data
      return this.$http
        .get(url, { params: this.csvParams })
        .then((response) => {
          response.data.forEach((item) => {
            asyncParser.input.push(item);
          });
          if (response.next_page_url) {
            return this.fetchCsvData(response.next_page_url, asyncParser);
          } else {
            asyncParser.input.push(null);
            return Promise.resolve(response);
          }
        })
        .catch((error) => {
          const message = get(
            error,
            " response.data.message",
            "Something went wrong while fetching csv data",
          );
          Notify.warning(message);
        });
    },
  },
};
</script>
